import { resources } from '../resources.js';

function getSubjectTimetable(section: any) {
    var subject = section.course.subject.id + ' ' + section.catalogCode + ' - ' + section.course.title;
    return subject;
}

function getSubjectEvent(section: any) {
    var subject = section.course.subject.id + ' ' + section.catalogCode + ' - ' + section.sectionCode + ' - ' + section.course.title;
    return subject;
}

function getTerm() {

    var term = {
        currentTerm: "",
        currentTermDescr: "",
        termStartDate: new Date(0),
        termEndDate: new Date(0),
    }

    var d = new Date();
    //console.log("d - "+d);
    var currentYear = d.getFullYear();
    //console.log("currentYear - " + currentYear)
    var currentYearArr = currentYear.toString().split('');

    var fallTermStart = new Date();
    fallTermStart.setFullYear(currentYear, 8, 1);
    fallTermStart.setHours(0,0,0,0);
    //console.log("fallTermStart - " + fallTermStart)

    var fallTermEnd = new Date();
    fallTermEnd.setFullYear(currentYear, 11, 31);
    fallTermEnd.setHours(23,59,59,999);
    //console.log("fallTermEnd - " + fallTermEnd)

    const springSummerTermStart = new Date();
    springSummerTermStart.setFullYear(currentYear, 4, 1);
    springSummerTermStart.setHours(0,0,0,0);
    //console.log("springSummerTermStart - " + springSummerTermStart)

    var springSummerTermEnd = new Date();
    springSummerTermEnd.setFullYear(currentYear, 7, 31);
    springSummerTermEnd.setHours(23,59,59,999);
    //console.log("springSummerTermEnd - " + springSummerTermEnd)

    var winterTermStart = new Date();
    winterTermStart.setFullYear(currentYear, 0 , 1);
    winterTermStart.setHours(0,0,0,0);
    //console.log("winterTermStart - " + winterTermStart)

    var winterTermEnd = new Date();
    winterTermEnd.setFullYear(currentYear, 3, 30);
    winterTermEnd.setHours(23,59,59,999);
    //console.log("winterTermEnd - " + winterTermEnd)

    if (d.getTime() >= winterTermStart.getTime() && d.getTime() <= winterTermEnd.getTime()) {
        //console.log("Winter")
        term.currentTerm = currentYearArr[0] + currentYearArr[2] + currentYearArr[3] + "1";
        term.termStartDate = winterTermStart;
        term.termEndDate = winterTermEnd;
        term.currentTermDescr = currentYear.toString() + " Winter Term";

    } else if (d.getTime() >= springSummerTermStart.getTime() && d.getTime() <= springSummerTermEnd.getTime()) {
        //console.log("Spring")
        term.currentTerm = currentYearArr[0] + currentYearArr[2] + currentYearArr[3] + "5"
        term.termStartDate = springSummerTermStart;
        term.termEndDate = springSummerTermEnd;
        term.currentTermDescr = currentYear.toString() + " Spring/Summer Term";

    } else if (d.getTime() >= fallTermStart.getTime() && d.getTime() <= fallTermEnd.getTime()) {
        //console.log("Fall")
        term.currentTerm = currentYearArr[0] + currentYearArr[2] + currentYearArr[3] + "9"
        term.termStartDate = fallTermStart;
        term.termEndDate = fallTermStart;
        term.currentTermDescr = currentYear.toString() + " Fall Term";
    }
    //console.log(JSON.stringify(term));
    return term;
}

function getFrequencyShort(meetings: any) {
    var frequency = "";

    if (meetings.monday) {
        frequency += " M";
    }

    if (meetings.tuesday) {
        frequency += " Tu";
    }

    if (meetings.wednesday) {
        frequency += " W";
    }

    if (meetings.thursday) {
        frequency += " Th";
    }

    if (meetings.friday) {
        frequency += " F";
    }

    if (meetings.saturday) {
        frequency += " Sat";
    }

    if (meetings.sunday) {
        frequency += " Sun";
    }

    //console.log(frequency)
    return frequency;
}

function getFrequencyEventMeetings(meetings: any) {
    var frequency = [];

    if (meetings.monday) {
        frequency.push("Monday");
    }

    if (meetings.tuesday) {
        frequency.push("Tuesday");
    }

    if (meetings.wednesday) {
        frequency.push("Wednesday");
    }

    if (meetings.thursday) {
        frequency.push("Thursday");
    }

    if (meetings.friday) {
        frequency.push("Friday");
    }

    if (meetings.saturday) {
        frequency.push("Saturday");
    }

    if (meetings.sunday) {
        frequency.push("Sunday");
    }

    //console.log(frequency)
    return frequency;

}

async function getHolidays() {
    const holidaysResponse = await fetch(
        resources.holidays.endpoint + getTerm().currentTerm, {
        method: 'GET',
        }
    )

    const holidaysResponseObject = await holidaysResponse.json();

    return holidaysResponseObject;
}

function sortTimetable(timetable: any, key: string) {

    if (timetable !== undefined) {

        return timetable.sections.sort(function (a: any, b: any) {
            var x = a[key]; var y = b[key];
            return ((x < y) ? -1 : ((x > y) ? 1 : 0));
        });

    } else {
        return timetable
    }
}

export { getSubjectTimetable, getSubjectEvent, getTerm, getFrequencyShort, getFrequencyEventMeetings, getHolidays, sortTimetable }
